import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: null,
	loading: false,
	error: null,
};

const pendingTasksSlice = createSlice({
	name: "pendingTasks",
	initialState,
	reducers: {
		fetchPendingTasksRequest: (state) => {
			state.loading = true;
			state.error = null;
		},
		fetchPendingTasksSuccess: (state, action) => {
			state.loading = false;
			state.data = action.payload;
		},
		fetchPendingTasksFailure: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},
	},
});

export const { fetchPendingTasksRequest, fetchPendingTasksSuccess, fetchPendingTasksFailure } = pendingTasksSlice.actions;

export default pendingTasksSlice.reducer;
